/*
 * View for the quick create response editor, which encloses the current topic response editor
 */

define([
  "marionette",
  "modules/quickCreate/quickResponseModal/template/quickResponseModalTemplate.html",
], function (Marionette, QuickResponseModalTemplate) {
  var QuickResponseModalView = {};

  QuickResponseModalView.quickResponseModalLayout = Marionette.Layout.extend({
    template: QuickResponseModalTemplate,
    getCompleteness: function () {
      return this.$el.find("#completeness").prop("checked");
    },
    regions: {
      editor: "#responseEditor",
    },
  });

  return QuickResponseModalView;
});
